const cache = new Map();
const inflight = new Map();

export function clearPortalQueryCache() {
  cache.clear();
  inflight.clear();
}

export function getCachedJson(url) {
  const entry = cache.get(url);
  return entry ? entry.value : undefined;
}

export function setCachedJson(url, value) {
  cache.set(url, { value, updatedAt: Date.now() });
}

export function invalidateCachedJson(url) {
  cache.delete(url);
  inflight.delete(url);
}

export async function fetchJsonCached(url, { ttlMs = 30_000, signal } = {}) {
  const existing = cache.get(url);
  const now = Date.now();
  if (existing && now - existing.updatedAt < ttlMs) {
    return existing.value;
  }

  if (inflight.has(url)) {
    return inflight.get(url);
  }

  const promise = (async () => {
    const response = await fetch(url, { credentials: 'include', signal });
    if (!response.ok) {
      const payload = await response.json().catch(() => null);
      const message = payload?.message || `Request failed: ${response.status}`;
      throw new Error(message);
    }

    const value = await response.json();
    setCachedJson(url, value);
    return value;
  })().finally(() => inflight.delete(url));

  inflight.set(url, promise);
  return promise;
}

export function prefetchJsonCached(url, options = {}) {
  // Fire-and-forget prefetch; errors are intentionally ignored.
  fetchJsonCached(url, options).catch(() => null);
}

